<template>
  <v-menu
    class="color-picker__wrapper"
    absolute
  >
  <template v-slot:activator="{ props }">
    <div 
      class="color-picker"
      v-bind="props"
    >
      <div
        class="palette"
        :style="paletteStyle"
      >
      </div>
    </div>
  </template>
  <div class="picker-wrapper">
    <v-color-picker
      elevation="8"
      hide-canvas
      hide-inputs
      hide-mode-switch
      hide-sliders
      mode="rgba"
      show-swatches
      swatches-max-height="200"
      :model-value="modelValue"
      @update:modelValue="onColorInput"
    ></v-color-picker>
  </div>
</v-menu>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({

  emits:['update:modelValue'],

  props: {
    modelValue: {
      type: String,
    }
  },
  computed: {
    paletteStyle() {
      return { backgroundColor: this.modelValue };
    }
  },
  methods: {
    onColorInput(value: string) {
      if (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
})
</script>
<style lang="scss">
.color-picker {
  cursor: pointer;
  padding: 0.5rem; 
  border: 1px solid #e0e0e0;
  border-radius: 4px;

  &:hover {
    background-color: #f0f0f0;
  }
}
.palette {
  height: 25px;
  width: 100%; /* 【超重要】幅を指定しないと0pxになって見えない */
  border-radius: 4px;
  border: 1px solid #ccc; /* 白系の色を選んだ時に背景と同化しないように枠線を追加 */
}

.picker-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.color-picker__wrapper {
  .v-menu__content {
    box-shadow: none !important;
  }
}
</style>

